import { Config } from './../classes/config';
import { DataService } from './../services/data.service';
import { Component, OnInit } from '@angular/core';
import { getConfig } from '../classes/getConfig/getConfig';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage implements OnInit {

  public oldPassword = '';
  public newPassword = '';
  public newPassword2 = '';

  public success = false;
  public error = false;
  public errorText = '';

  public config: Config;

  constructor(private dataService: DataService) {
    this.config = getConfig();
  }

  ngOnInit() {

  }

  change() {
    this.success = false;
    this.error = false;
    this.dataService.changePasswort(this.oldPassword, this.newPassword)
    .then(() => {
      this.oldPassword = '';
      this.newPassword = '';
      this.newPassword2 = '';
      this.success = true;
    })
    .catch((err) => {
      this.error = true;
      this.errorText = err;
    });
  }
}
